import {AbstractFormConfig} from "../abstract-form.config";

export class FormInputConfig extends AbstractFormConfig {

  public keyDelay: number | undefined;
  public placeholder: string | undefined;
  public uppercase: boolean = false;

  constructor(init?: Partial<FormInputConfig> | undefined) {
    super(init);
    Object.assign(this, init);
  }
}
